import React from "react";
import S from "./RelatedPosts.styled";
import GreenArrow from "@/src/images/GreenArrow.png";

type Props = {
  post: any;
};

const RelatedPosts = ({ post }: Props) => {
  const date = (date: string) => {
    const split = date.split(",");
    return split[0];
  };

  return (
    <S.Wrapper>
      <S.Link href={post.uri}>
        <S.LeftWrapper>
          <S.Date>{date(post.date)}</S.Date>
          {post.categories && (
            <S.Category>{post.categories.nodes[0].name}</S.Category>
          )}
        </S.LeftWrapper>
        <S.RightWrapper>
          <S.Title>{post.title}</S.Title>
          <S.Arrow src={GreenArrow} alt="arrow" />
        </S.RightWrapper>
      </S.Link>
    </S.Wrapper>
  );
};

export default RelatedPosts;
